import { useEffect } from "react";
import useProfiler from "../../../hooks/useProfiler.js";
import { createTrackingUtils } from "../index.js";
import useRouteName from "../../../hooks/useRouteName.js";
export const flights_web_change_airport_messaging = createTrackingUtils({
    name: "flights_web_change_airport_messaging",
    defaultStage: 1,
    stages: {
        main: 1,
        fd: 2,
        ddot: 3,
        mdot: 4,
        direct: 5,
        meta: 6
    },
    goals: {},
    goalsWithValue: []
});
export function useTrackFlightsWebChangeAirportMessaging(canTrack) {
    const { isDesktop, isMobile, isDirect, isMeta } = useProfiler();
    const routename = useRouteName();
    useEffect(() => {
        if (!canTrack)
            return;
        if (routename !== "flightdetails")
            return;
        flights_web_change_airport_messaging.stages.fd();
        if (isDesktop())
            flights_web_change_airport_messaging.stages.ddot();
        if (isMobile())
            flights_web_change_airport_messaging.stages.mdot();
        if (isDirect())
            flights_web_change_airport_messaging.stages.direct();
        if (isMeta())
            flights_web_change_airport_messaging.stages.meta();
    }, [canTrack, routename, isDesktop, isMobile, isDirect, isMeta]);
}
